import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";

export const Content = ({ className, title, titleColour, content, heading }) => {
  return (
    <section className={cn(styles.Content, className)}>
      <Container>
        {title && <h2 className={cn(styles.title, heading, styles[titleColour?.variant])} style={titleColour?.custom ? { color: titleColour?.custom } : null}>{title}</h2>}
        {content && (
          <div
            className={cn(styles.desc)}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </Container>
    </section>
  );
};

export default Content;
